import { Link, generatePath, useLocation } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses.js';
import { paths } from '../../common/constants/pathVariables.js';
import { addBillingAgreementMsg, saveMsg, t } from '../../common/i18n/index.js';
import { Anchor } from '../Anchor/Anchor.js';
import { ButtonGroupForSubmitAndBack } from '../ButtonGroupForSubmitAndBack/ButtonGroupForSubmitAndBack.js';
import { Grid } from '../Grid/Grid.js';
import { StickyFooter } from '../StickyFooter/index.js';
import type { BillingAccountHeader } from '../../generated/api/models.js';
import type { JSX } from 'react';

export const EditCatalogButtonGroup = (editCatalogButtonElementProps: {
  isSaving?: boolean;
  onSave?: () => void;
  onCancel: () => void;
  saveDisabled?: boolean;
}): JSX.Element => {
  return (
    <StickyFooter active={true}>
      <Grid>
        <ButtonGroupForSubmitAndBack
          className={`${dsClass.TEXT_ALIGN_RIGHT} ${dsClass.MARGIN_VERTICAL_3}`}
          onCancel={() => {
            editCatalogButtonElementProps.onCancel();
          }}
          onSubmit={() => {
            editCatalogButtonElementProps.onSave?.();
          }}
          submitButtonText={t.NIWE(saveMsg)}
          submitting={editCatalogButtonElementProps.isSaving}
          size="l"
          submitDisabled={editCatalogButtonElementProps.saveDisabled}
        />
      </Grid>
    </StickyFooter>
  );
};

export const BillingAccountSelection = (billingAccountSelectionProps: {
  billingAccounts?: BillingAccountHeader[];
  currentBillingAccountId?: string;
  onUpdateBillingAccount: () => void;
}): JSX.Element => {
  const { search, state } = useLocation();
  const { billingAccounts, currentBillingAccountId, onUpdateBillingAccount } = billingAccountSelectionProps;

  if (billingAccounts) {
    const currentBillingAccountDisplayId =
      state?.newBillingAccountDisplayId ||
      (currentBillingAccountId &&
        billingAccounts.find(billingAccount => billingAccount.billingAccountId === currentBillingAccountId)
          ?.billingAccountDisplayId);

    return (
      <span>
        {currentBillingAccountDisplayId ? (
          <span>
            <Link
              className="of-catalog-details__to-billing-account"
              to={
                generatePath(paths.BILLING_ACCOUNT, {
                  billingAccountId: currentBillingAccountDisplayId,
                }) + search
              }
            >
              {currentBillingAccountDisplayId}
            </Link>
          </span>
        ) : (
          <span>
            <Anchor className="of-catalog-details__change-billing-account" onClick={() => onUpdateBillingAccount()}>
              {t.G18X(addBillingAgreementMsg)}
            </Anchor>
          </span>
        )}
      </span>
    );
  }
  return <></>;
};
